// // import React from "react";
// // import { Routes, Route, useLocation, Navigate } from "react-router-dom";
// // import Navbar from "./components/Navbar";
// // import Home from "./components/Home";
// // import Overview from "./pages/Overview";
// // import ManagementStandardsVision from "./pages/ManagementStandardsVision";
// // import JointVenturePartners from "./pages/JointVenturePartners";
// // import Statistics from "./pages/Statistics";
// // import Map from "./pages/Map";
// // import Cargoes from "./pages/Cargoes";
// // import InlandLogistics from "./pages/InlandLogistics";
// // import WestEastBound from "./pages/WestEastBound";
// // import IntraAsia from "./pages/IntraAsia";
// // import MultiPurposeVessels from "./pages/MultiPurposeVessels";
// // import PureCarTruckCarriers from "./pages/PureCarTruckCarriers";
// // import Careers from "./components/Careers";
// // import ContactUs from "./components/ContactUs";
// // import Footer from "./components/Footer";
// // import Gallery from "./pages/Gallery";
// // import Login from "./pages/Login";
// // import Register from "./pages/Register";
// // import AdminEquipment from "./pages/AdminEquipment";
// // import Dashboard from "./pages/Dashboard";
// // import AdminProfile from "./pages/AdminProfile";
// // import AdminSchedule from "./pages/AdminSchedule";
// // import PrivacyStatement from "./pages/PrivacyStatement";
// // import AdminNavbar from "./pages/AdminNavbar";

// // // Authentication check component
// // const ProtectedRoute = ({ children }) => {
// //   const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
  
// //   if (!isAdmin) {
// //     console.log('Not authenticated, redirecting to login');
// //     return <Navigate to="/login" replace />;
// //   }
  
// //   return children;
// // };

// // const App = () => {
// //   const location = useLocation();
  
// //   // Check if current path is an admin route
// //   const isAdminRoute = location.pathname.startsWith("/admin") || location.pathname === "/dashbord";

// //   return (
// //     <>
// //       {/* Conditionally render AdminNavbar or regular Navbar based on route */}
// //       {isAdminRoute ? <AdminNavbar /> : <Navbar />}

// //       <Routes>
// //         {/* Public routes */}
// //         <Route path="/" element={<Home />} />
// //         <Route path="/overview" element={<Overview />} />
// //         <Route path="/management-standards-vision" element={<ManagementStandardsVision />} />
// //         <Route path="/joint-venture-partners" element={<JointVenturePartners />} />
// //         <Route path="/statistics" element={<Statistics />} />
// //         <Route path="/map" element={<Map />} />
// //         <Route path="/cargoes" element={<Cargoes />} />
// //         <Route path="/inland-logistics" element={<InlandLogistics />} />
// //         <Route path="/west-east-bound" element={<WestEastBound />} />
// //         <Route path="/intra-asia" element={<IntraAsia />} />
// //         <Route path="/multi-purpose-vessels" element={<MultiPurposeVessels />} />
// //         <Route path="/pure-car-truck-carriers" element={<PureCarTruckCarriers />} />
// //         <Route path="/gallery" element={<Gallery />} />
// //         <Route path="/careers" element={<Careers />} />
// //         <Route path="/contact-us" element={<ContactUs />} />
// //         <Route path="/westeastbound" element={<WestEastBound />} />
// //         <Route path="/privacystatement" element={<PrivacyStatement />} />

// //         {/* Login and Register routes */}
// //         <Route path="/login" element={<Login />} />
// //         <Route path="/register" element={<Register />} />
        
// //         {/* Admin routes with protection */}
// //         <Route path="/dashbord" element={
// //           <ProtectedRoute>
// //             <Dashboard />
// //           </ProtectedRoute>
// //         } />
// //         <Route path="/admin/profile" element={
// //           <ProtectedRoute>
// //             <AdminProfile />
// //           </ProtectedRoute>
// //         } />
// //         <Route path="/admin/equipment" element={
// //           <ProtectedRoute>
// //             <AdminEquipment />
// //           </ProtectedRoute>
// //         } />
// //         <Route path="/admin/schedule" element={
// //           <ProtectedRoute>
// //             <AdminSchedule />
// //           </ProtectedRoute>
// //         } />
        
// //         {/* Redirect /admin to dashboard */}
// //         <Route path="/admin" element={<Navigate to="/dashbord" replace />} />
        
// //         {/* Catch-all route - redirect to home */}
// //         <Route path="*" element={<Navigate to="/" replace />} />
// //       </Routes>
      
// //       {/* Don't show footer on admin routes */}
// //       {!isAdminRoute && <Footer />}
// //     </>
// //   );
// // };

// // export default App;





// import React from "react";
// import { Routes, Route, useLocation, Navigate } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Home from "./components/Home";
// import Overview from "./pages/Overview";
// import ManagementStandardsVision from "./pages/ManagementStandardsVision";
// import JointVenturePartners from "./pages/JointVenturePartners";
// import Statistics from "./pages/Statistics";
// import Map from "./pages/Map";
// import Cargoes from "./pages/Cargoes";
// import InlandLogistics from "./pages/InlandLogistics";
// import WestEastBound from "./pages/WestEastBound";
// import IntraAsia from "./pages/IntraAsia";
// import MultiPurposeVessels from "./pages/MultiPurposeVessels";
// import PureCarTruckCarriers from "./pages/PureCarTruckCarriers";
// import Careers from "./components/Careers";
// import ContactUs from "./components/ContactUs";
// import Footer from "./components/Footer";
// import Gallery from "./pages/Gallery";
// import Login from "./pages/Login";
// import Register from "./pages/Register";
// import AdminEquipment from "./pages/AdminEquipment";
// import Dashboard from "./pages/Dashboard";
// import AdminProfile from "./pages/AdminProfile";
// import AdminSchedule from "./pages/AdminSchedule";
// import PrivacyStatement from "./pages/PrivacyStatement";
// import TermsOfUse from "./pages/TermsOfUse";
// import AdminNavbar from "./pages/AdminNavbar";

// // Authentication check component
// const ProtectedRoute = ({ children }) => {
//   const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
  
//   if (!isAdmin) {
//     console.log('Not authenticated, redirecting to login');
//     return <Navigate to="/login" replace />;
//   }
  
//   return children;
// };

// const App = () => {
//   const location = useLocation();
  
//   // Check if current path is an admin route
//   const isAdminRoute = location.pathname.startsWith("/admin") || location.pathname === "/dashbord";

//   return (
//     <>
//       {/* Conditionally render AdminNavbar or regular Navbar based on route */}
//       {isAdminRoute ? <AdminNavbar /> : <Navbar />}

//       <Routes>
//         {/* Public routes */}
//         <Route path="/" element={<Home />} />
//         <Route path="/overview" element={<Overview />} />
//         <Route path="/management-standards-vision" element={<ManagementStandardsVision />} />
//         <Route path="/joint-venture-partners" element={<JointVenturePartners />} />
//         <Route path="/statistics" element={<Statistics />} />
//         <Route path="/map" element={<Map />} />
//         <Route path="/cargoes" element={<Cargoes />} />
//         <Route path="/inland-logistics" element={<InlandLogistics />} />
//         <Route path="/west-east-bound" element={<WestEastBound />} />
//         <Route path="/intra-asia" element={<IntraAsia />} />
//         <Route path="/multi-purpose-vessels" element={<MultiPurposeVessels />} />
//         <Route path="/pure-car-truck-carriers" element={<PureCarTruckCarriers />} />
//         <Route path="/gallery" element={<Gallery />} />
//         <Route path="/careers" element={<Careers />} />
//         <Route path="/contact-us" element={<ContactUs />} />
//         <Route path="/westeastbound" element={<WestEastBound />} />
        
//         {/* Privacy Statement Routes - handle both cases for compatibility */}
//         <Route path="/privacy-statement" element={<PrivacyStatement />} />
//         <Route path="/privacystatement" element={<PrivacyStatement />} />
        
//         {/* Terms of Use Routes - handle both cases for compatibility */}
//         <Route path="/terms-of-use" element={<TermsOfUse />} />
//         <Route path="/termsofuse" element={<TermsOfUse />} />
        
//         {/* Login and Register routes */}
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
        
//         {/* Admin routes with protection */}
//         <Route path="/dashbord" element={
//           <ProtectedRoute>
//             <Dashboard />
//           </ProtectedRoute>
//         } />
//         <Route path="/admin/profile" element={
//           <ProtectedRoute>
//             <AdminProfile />
//           </ProtectedRoute>
//         } />
//         <Route path="/admin/equipment" element={
//           <ProtectedRoute>
//             <AdminEquipment />
//           </ProtectedRoute>
//         } />
//         <Route path="/admin/schedule" element={
//           <ProtectedRoute>
//             <AdminSchedule />
//           </ProtectedRoute>
//         } />
        
//         {/* Redirect /admin to dashboard */}
//         <Route path="/admin" element={<Navigate to="/dashbord" replace />} />
        
//         {/* Catch-all route - redirect to home */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
      
//       {/* Don't show footer on admin routes */}
//       {!isAdminRoute && <Footer />}
//     </>
//   );
// };

// export default App;








import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Overview from "./pages/Overview";
import ManagementStandardsVision from "./pages/ManagementStandardsVision";
import JointVenturePartners from "./pages/JointVenturePartners";
import Statistics from "./pages/Statistics";
import Map from "./pages/Map";
import Cargoes from "./pages/Cargoes";
import InlandLogistics from "./pages/InlandLogistics";
import WestEastBound from "./pages/WestEastBound";
import IntraAsia from "./pages/IntraAsia";
import MultiPurposeVessels from "./pages/MultiPurposeVessels";
import PureCarTruckCarriers from "./pages/PureCarTruckCarriers";
import Careers from "./components/Careers";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import Gallery from "./pages/Gallery";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminEquipment from "./pages/AdminEquipment";
import Dashboard from "./pages/Dashboard";
import AdminProfile from "./pages/AdminProfile";
import AdminSchedule from "./pages/AdminSchedule";
import PrivacyStatement from "./pages/PrivacyStatement";
import TermsOfUse from "./pages/TermsOfUse";
import AdminNavbar from "./pages/AdminNavbar";
import AdminMasterEquipment from "./pages/AdminMasterEquipment";
import AdminCategory from "./pages/AdminCategory";
import AdminAttribute from "./pages/AdminAttribute";


// Authentication check component
const ProtectedRoute = ({ children }) => {
  const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
  
  if (!isAdmin) {
    console.log('Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const App = () => {
  const location = useLocation();
  
  // Check if current path is an admin route
  const isAdminRoute = location.pathname.startsWith("/admin") || location.pathname === "/dashbord";

  return (
    <>
      {/* Conditionally render AdminNavbar or regular Navbar based on route */}
      {isAdminRoute ? <AdminNavbar /> : <Navbar />}

      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/management-standards-vision" element={<ManagementStandardsVision />} />
        <Route path="/joint-venture-partners" element={<JointVenturePartners />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/map" element={<Map />} />
        <Route path="/cargoes" element={<Cargoes />} />
        <Route path="/inland-logistics" element={<InlandLogistics />} />
        <Route path="/west-east-bound" element={<WestEastBound />} />
        <Route path="/intra-asia" element={<IntraAsia />} />
        <Route path="/multi-purpose-vessels" element={<MultiPurposeVessels />} />
        <Route path="/pure-car-truck-carriers" element={<PureCarTruckCarriers />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/westeastbound" element={<WestEastBound />} />
      
        
        {/* Privacy Statement Routes - handle both cases for compatibility */}
        <Route path="/privacy-statement" element={<PrivacyStatement />} />
        <Route path="/privacystatement" element={<PrivacyStatement />} />
        
        {/* Terms of Use Routes - handle both cases for compatibility */}
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/termsofuse" element={<TermsOfUse />} />
        
        {/* Login and Register routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Admin routes with protection */}
        <Route path="/dashbord" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/profile" element={
          <ProtectedRoute>
            <AdminProfile />
          </ProtectedRoute>
        } />
        <Route path="/admin/equipment" element={
          <ProtectedRoute>
            <AdminEquipment />
          </ProtectedRoute>
        } />
        <Route path="/admin/schedule" element={
          <ProtectedRoute>
            <AdminSchedule />
          </ProtectedRoute>
        } />
        
        {/* New Master Equipment routes */}
        <Route path="/admin/master-equipment" element={
          <ProtectedRoute>
            <AdminMasterEquipment />
          </ProtectedRoute>
        } />
        <Route path="/admin/master-equipment/category" element={
          <ProtectedRoute>
            <AdminCategory />
          </ProtectedRoute>
        } />
        <Route path="/admin/master-equipment/attribute" element={
          <ProtectedRoute>
            <AdminAttribute />
          </ProtectedRoute>
        } />
        
        {/* Redirect /admin to dashboard */}
        <Route path="/admin" element={<Navigate to="/dashbord" replace />} />
        
        {/* Catch-all route - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
      {/* Don't show footer on admin routes */}
      {!isAdminRoute && <Footer />}
    </>
  );
};

export default App;